export var fonts = {
  font_sizes: {
    header: {
      sm: 20,
      sm1: 20,
      md: 24,
      md1: 24,
      lg: 32,
      xl: 40,
      xl1: 40
    },
    par: {
      sm: 12,
      md: 14,
      lg: 17,
      xl: 20
    }
  },
  font_family: '"MTS Sans", "Arial", "Helvetica", sans-serif',
  font_weights: {
    regular: 400,
    medium: 500,
    bold: 700,
    black: 900
  },
  line_heights: {
    header: {
      sm: 24,
      sm1: 28,
      md: 28,
      md1: 32,
      lg: 36,
      xl: 44,
      xl1: 48
    },
    par: {
      sm: 16,
      md: 20,
      lg: 24,
      xl: 24
    }
  },
  bottom_margins: {
    sm: 8,
    md: 16,
    lg: 24,
    xl: 32
  }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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